import React, { useCallback, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  Label,
  Form,
  Button,
  ModalFooter,
  ModalBody,
  ModalHeader,
  Modal,
} from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainer from "../../components/Common/TableContainer";
import { post } from "../../helpers/api_helper";
import { LEDGER_REPORT } from "../../helpers/url_helper";
import { useForm, Controller } from "react-hook-form";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import toastr from "toastr";
import TransactionReportColumns from "components/Columns/TransactionReportColumn";

const REPORT_TYPE = {
  TRANSACTION_REPORT: "transaction_report",
};

const TransactionReport = () => {
  const [report, setReport] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isReportGenerated, setIsReportGenerated] = useState(false);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [totalAmount, setTotalAmount] = useState(0)
  const breadcrumbItems = [
    { title: "valfuel", link: "/" },
    { title: "Reports", link: "#" },
  ];

  const { handleSubmit, control } = useForm({
    defaultValues: {
      customer_ul_id: [],
      start_date: new Date().toISOString().split("T")[0],
      end_date: new Date().toISOString().split("T")[0],
    },
  });

  const fetchReport = async (formData, userInitiated = false) => {
    try {
      setLoading(true);

      const startDate = new Date(formData.start_date);
      const syyyy = startDate.getFullYear();
      const smm = String(startDate.getMonth() + 1).padStart(2, "0");
      const sdd = String(startDate.getDate()).padStart(2, "0");

      const endDate = new Date(formData.end_date);
      const eyyyy = endDate.getFullYear();
      const emm = String(endDate.getMonth() + 1).padStart(2, "0");
      const edd = String(endDate.getDate()).padStart(2, "0");
      setFromDate(`${syyyy}-${smm}-${sdd}`);
      setToDate(`${eyyyy}-${emm}-${edd}`);

      const payload = {
        start_date: `${syyyy}-${smm}-${sdd}`,
        end_date: `${eyyyy}-${emm}-${edd}`,
        report_type: REPORT_TYPE.TRANSACTION_REPORT
      };

      const response = await post(LEDGER_REPORT, payload);
      setReport(response.data || []);
      setTotalPages(response.data.totalPages || 1);
      setTotalAmount(response.totalAmount)

      if (userInitiated) {
        setIsReportGenerated(true);
      }
    } catch (error) {
      console.error("Failed to fetch report:", error);
      toastr.error("Failed to generate report.");
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(
    () => TransactionReportColumns(),
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title="Custom Report"
            breadcrumbItems={breadcrumbItems}
          />

          <Card>
            <CardBody>
              <Form onSubmit={handleSubmit((data) => fetchReport(data, true))}>
                <Row className="align-items-end">
                  <Col md={2}>
                    <Label>Start Date</Label>
                    <Controller
                      name="start_date"
                      control={control}
                      render={({ field }) => (
                        <Flatpickr
                          {...field}
                          className="form-control"
                          options={{
                            dateFormat: "Y-m-d",
                            maxDate: "today",
                          }}
                        />
                      )}
                    />
                  </Col>
                  <Col md={2}>
                    <Label>End Date</Label>
                    <Controller
                      name="end_date"
                      control={control}
                      render={({ field }) => (
                        <Flatpickr
                          {...field}
                          className="form-control"
                          options={{
                            dateFormat: "Y-m-d",
                            maxDate: "today",
                          }}
                        />
                      )}
                    />
                  </Col>
                  <Col md={2}>
                    <Button color="primary" type="submit" className="w-100">
                      Generate Report
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>

          <Card>
            <CardBody>
              {loading ? (
                <div className="text-center">Loading...</div>
              ) : isReportGenerated ? (
                report.length > 0 ? (
                  <>
                    <TableContainer
                        columns={columns}
                        data={report}
                        isPagination={true}
                        customPageSize={pageSize}
                        iscustomPageSize={false}
                        isBordered={false}
                        controlledPagination={{
                        pageIndex,
                        setPageIndex,
                        pageSize,
                        setPageSize,
                        totalPages,
                        }}
                        showTotalField={true}
                        total={totalAmount}
                        totalLabel={'Total'}
                    />
                  </>
                ) : (
                  <div className="text-center text-danger">
                    <h4 className="py-5">
                      No records found for the selected date.
                    </h4>
                  </div>
                )
              ) : (
                <div className="text-center text-muted">
                  <h4>Please select a date and generate the report.</h4>
                </div>
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TransactionReport;
